import React, { useMemo } from 'react'

import { Helmet } from 'react-helmet'

import APIErrorToast from '@components/APIErrorToast'
import Banner from '@components/shared/Banner'
import LayoutProvider from '@providers/LayoutProvider'
import { useSession } from '@stores/globalData/globalData.store'

import Footer from './Footer'
import Header from './header/Header'

import type { SearchConfig } from '@services/SearchService'
import type { FC, PropsWithChildren } from 'react'

type Props = PropsWithChildren<{
  hideHeader?: boolean
  hideFooter?: boolean
  searchConfig?: SearchConfig
  title?: string
  canonicalUrl?: string
}>

const PageLayout: FC<Props> = ({
  hideHeader,
  hideFooter,
  searchConfig,
  children,
  title,
  canonicalUrl,
}: Props) => {
  const session = useSession()

  const pageTitle = useMemo(() => {
    if (session.isDefaultCommunity()) {
      return title || session.community.name
    } else {
      return title ? `${session.community.name} - ${title}` : session.community.name
    }
  }, [title, session.community])
  return (
    <LayoutProvider initialTitle={pageTitle}>
      <main
        className={`inset-0 antialiased flex flex-row h-screen overflow-x-hidden bg-gray-light text-black dark:bg-black-bg dark:text-gray ${session?.plan}`}>
        <Helmet>{canonicalUrl && <link rel="canonical" href={canonicalUrl} />}</Helmet>
        <div className="flex flex-col flex-1">
          <Banner />
          {!hideHeader && <Header searchConfig={searchConfig} />}
          <div className="relative flex flex-col flex-1 scroll-overlay">
            <APIErrorToast headerVisible={!hideHeader} />
            {children}
            {!hideFooter && <Footer />}
          </div>
        </div>
      </main>
    </LayoutProvider>
  )
}

export default PageLayout
